<div class="page-actions">
  @if (availableFilters$ | async; as availableFilters) {
    <dv-filter-area
      class="page-actions__filter-area"
      [availableFilters]="availableFilters | vtFilterPermissions"
      [isFilterPanelOpen]="isTripFilterAreaOpen"
      [openPanelTooltip]="'Report.FilterPanel.Open' | translate"
      [closePanelTooltip]="'Report.FilterPanel.Close' | translate"
      [addFilterFn]="addNewFilter"
      (activeFilterChanged)="onActiveFilterChanged($event)"
      (filterAreasVisibilityToggled)="
        onFilterAreaToggled($event)
      "></dv-filter-area>
  }
</div>
<dv-vertical-splitter
  [resizableSide]="resizableSide.Right"
  id="trips-vertical-splitter"
  class="trips-page">
  <div left-side>
    <app-trips-grid
      #tripsGrid
      [selectedFilterName]="selectedFilterName!"
      (clearGridFiltersClicked)="onClearGridFiltersClicked()"></app-trips-grid>
  </div>
  <div right-side>
    <router-outlet />
  </div>
</dv-vertical-splitter>
